<template>
  <CustomTable ref="table" class="compact-table" :elements=elements :data="data" :searchOptions="searchOptions" :loadData="loadData">
    <template v-slot:header-options>
      <button class="button-icon" title="Enregistrer un décaissement" @click="$refs.disbursementModal.openModal()"><span class="fas fa-plus"></span></button>
    </template>
    <template v-slot:table>
      <thead v-if="$refs.table">
        <tr>
          <custom-header field="date" class="col-fit">Date</custom-header>
          <custom-header field="supplierName" class="col-fit" :sortable="false">Fournisseur</custom-header>
          <custom-header field="purchaseLabel" class="col-fill" :sortable="false">Achat</custom-header>
          <custom-header field="paymentType" class="hide-for-mobile col-fit">Mode de paiement</custom-header>
          <custom-header field="reference" class="hide-for-mobile col-fit">Référence</custom-header>
          <custom-header field="amount" class="col-fit">Montant TTC</custom-header>
        </tr>
      </thead>
      <tbody v-if="data && data.length > 0">
        <tr v-for="disbursement in $refs.table.$refs.searchArray.simpleFilter(data)" :key="disbursement.id" class="business-row" @click="$refs.disbursementModal.openModal({disbursement})">
          <custom-body field="date" class="col-fit">{{ formatDate(disbursement.date) }}</custom-body>
          <custom-body field="supplierName" class="col-fit col-truncate" :title="disbursement.supplierName">{{ disbursement.supplierName }}</custom-body>
          <custom-body field="purchaseLabel" class="col-fill" :title="disbursement.purchaseLabel">
            <span v-if="disbursement.isRefund" class="icon" title="Remboursement d'un avoir fournisseur : l'argent revient"><span class="fas fa-rotate-left"></span></span>
            {{ disbursement.purchaseLabel }}<template v-if="disbursement.purchaseReference"> ({{ disbursement.purchaseReference }})</template>
          </custom-body>
          <custom-body field="paymentType" class="hide-for-mobile col-fit">{{ labelOf(DISBURSEMENT_PAYMENT_TYPE_ENUM, disbursement.paymentType) }}</custom-body>
          <custom-body field="reference" class="hide-for-mobile col-fit col-truncate" :title="disbursement.reference || '-'">{{ disbursement.reference || '-' }}</custom-body>
          <custom-body field="amount" class="col-fit amount">{{ formatAmount(disbursement.isRefund ? -disbursement.amount : disbursement.amount) }}</custom-body>
        </tr>
      </tbody>
      <tbody v-else><tr class="empty-row"><td colspan="6" style="text-align: center">Aucun décaissement enregistré</td></tr></tbody>
    </template>
  </CustomTable>
  <DisbursementModal ref="disbursementModal" :callback=loadData />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import CustomTable from "@/components/CustomTable.vue";
import CustomHeader from "@/components/tables/CustomHeader.vue";
import CustomBody from "@/components/tables/CustomBody.vue";
import {SORT_OPERATOR_ENUM} from "@/models/sortOperatorEnum";
import {DisbursementController} from "@/purchase/controllers/DisbursementController";
import DisbursementModal from "@/purchase/components/modals/DisbursementModal.vue";
import {DISBURSEMENT_PAYMENT_TYPE_ENUM, formatAmount, formatDate, labelOf} from "@/purchase/utils";
library.add(faPlus, faRotateLeft);

// Décaissements : un remboursement d'avoir fournisseur est une entrée d'argent, il s'affiche en négatif
export default {
  name: 'DisbursementTable',
  components: {DisbursementModal, CustomBody, CustomHeader, CustomTable},
  data() {
    return {
      data: [],
      elements: [
        {label: "Date", value: "date", type: "date"},
        {label: "Mode de paiement", value: "paymentType", type: "select", values: DISBURSEMENT_PAYMENT_TYPE_ENUM},
        {label: "Référence", value: "reference", type: "text"},
        {label: "Montant TTC", value: "amount", type: "number"},
        {label: "Actions", value: undefined, type: undefined},
      ],
      searchOptions: {
        filters: [],
        sorts: [{field: "date", order: SORT_OPERATOR_ENUM.DESCENDING.value}]
      },
      DISBURSEMENT_PAYMENT_TYPE_ENUM
    };
  },
  async mounted() {
    this.$refs.table.$refs.searchArray.initWithURLParams();
    await this.loadData();
  },
  methods: {
    formatAmount,
    formatDate,
    labelOf,
    async loadData() {
      this.$refs.table?.startLoading();
      this.data = [];
      const resp = await DisbursementController.getTable(this.$refs.table.buildURLParams());
      if (!resp.errors) {
        this.data.push(...resp);
      }
      this.$refs.table?.stopLoading();
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';
@require '~/src/common/style/businessTable.styl';

.button-icon
  margin-right 10px

.icon
  margin-right 6px
  color #6b7280

.amount
  text-align right
  font-variant-numeric tabular-nums
</style>
